import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const boApi = {
    //分頁查詢訂單
    "queryInsideBoByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/queryInsideBoByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                commonref: null,
                companycode: null,
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //刪除訂單
    "delInsideBo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/delInsideBo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                commonref: null
            }
        }
    },
    //刪除訂單
    "delBo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/delBo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                commonref: null
            }
        }
    },

    //新增參展訂單
    "newHallBo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/newHallBo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo3: null,
                name: null,
                telephone: null,
                boproducts: []
            }
        }
    }
    ,
    //新增參展訂單
    "insertNewHallBo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/insertNewHallBo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo3: null,
                name: null,
                telephone: null,
                address: null,
                orderref:null,
                boproducts: []
            }
        }
    },
    "queryBoDetail": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/queryBoDetail`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
            }
        }
    },
    "updateBoVerify": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/updateBoVerify`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                verify:null
            }
        }
    },

    "queryHallBoByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}bo/queryHallBoByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                orderref: null,
                companycode: null,
                pageNum: 1,
                pageSize: 10
            }
        }
    }


}

export default boApi